import { useSelector } from 'modules/react-redux';
import moment from 'moment';
import { getRequest } from 'pages/requestForm/selectors/pageSelectors';
import { memo } from 'react';

import { messages } from './CurrencyDisclaimer.messages';
import { Root } from './CurrencyDisclaimer.styles';
import { CurrencyDisclaimerProps } from './CurrencyDisclaimer.types';

const CurrencyDisclaimer = memo<CurrencyDisclaimerProps>((props) => {
    const { companyCurrency, requestCurrency, exchangeRate } = props;

    const request = useSelector(getRequest);

    if (companyCurrency === requestCurrency) {
        return null;
    }

    const hasExchangeRateValue = request.exchangeRate !== null;

    const hasSubmittedExchangeRateValue =
        hasExchangeRateValue && !request.isManualExchangeRate && request.exchangeRateDate;

    if (hasSubmittedExchangeRateValue) {
        return (
            <Root>
                {messages.exchangeRateText({
                    currency: requestCurrency,
                    baseCurrency: companyCurrency,
                    rate: request.exchangeRate,
                })}

                <span>{` (${moment.utc(request.exchangeRateDate).format('ll')}, QBooks Online)`}</span>
            </Root>
        );
    }

    return (
        <Root>
            {exchangeRate !== null
                ? messages.manualRateDisclaimer({
                      defaultCurrency: companyCurrency,
                      selectedCurrency: requestCurrency,
                      exchangeRate,
                  })
                : messages.autoRateDisclaimer({
                      date: <b>{moment.utc().format('ll')}</b>,
                      rateProvider: 'QBooks Online',
                  })}
        </Root>
    );
});

export default CurrencyDisclaimer;
